import React from 'react';
import paytmPayIcon from '../../assets/images/icons/icons8-paytm-48.png';

const GPayPaymentTitle = () => {
  return (
    <img
      alt="gpay"
      src={paytmPayIcon}
      height="50"
      width="50"
      style={{ border: '1px solid #1890ff', borderRadius: '100%' }}
    />
  );
};

export default GPayPaymentTitle;
